import { useState, useEffect } from "react";
import { ReactComponent as LikeIcon } from "../../assets/icons/newsroom/newsdisplay/like.svg";
import EditIcon from '../../assets/icons/voyages/edit.svg';
import deleteNotificationIcon from "../../assets/icons/notifications/delete.svg";
import { useDispatch, useSelector } from "react-redux";
import { toggleModal, updateModalInfo } from "../../features/App/AppSlice";
import { newsRoomData, updateLikestatus, setSelectedNewsData, editNews, deleteSelectedNewsRoom, deleteNews } from "../../features/NewsRoom/NewsRoomSlice";
import { Input, DatePicker, Modal, Button, Form, Upload } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const NewsDisplay = () => {
  const dispatch = useDispatch();
  const { selectedNewsData, newsList, selectedNewsID } = useSelector((state) => state.newsroom);
  const { user } = useSelector((state) => state.user);
const isAdmin = user?.is_admin === true || user?.role === "admin";  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const changeLikeStatus = (news_id, status) => {
    dispatch(updateLikestatus({ liked: status, news_id })).then((result) => {
      if (result.payload) dispatch(newsRoomData());
    });
  };

  useEffect(() => {
    if (newsList.length !== 0 && selectedNewsID !== null) {
      dispatch(setSelectedNewsData(newsList.filter((v) => v.id === selectedNewsID)[0]));
    }
  }, [newsList]);

  if (!selectedNewsData) {
    return (
      <div className="nm-display-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', minHeight: '300px' }}>
        <p>Select a news article to read</p>
      </div>
    );
  }

  const openModal = () => {
    form.resetFields();
    form.setFieldsValue({ title: selectedNewsData?.title, description: selectedNewsData?.description });
    setModalVisible(true);
  };

  const handleSubmit = async (values) => {
    const { title, description, publishDate, thumbnail } = values;
    const thumbnailFile = thumbnail?.[0]?.originFileObj;
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('publish_date', publishDate.format('YYYY-MM-DD'));
    formData.append('id', selectedNewsID);
    if (thumbnailFile) formData.append('thumbnail_file', thumbnailFile);

    dispatch(editNews(formData)).then((result) => {
      if (result.payload) {
        dispatch(toggleModal());
        dispatch(updateModalInfo({ show: true, result: 'News Edited Successfully!', type: 'success', message: 'Success!' }));
      } else {
        dispatch(toggleModal());
        dispatch(updateModalInfo({ show: true, result: 'News Edit Failed!', type: 'error', message: 'Failed' }));
      }
    }).catch((error) => {
      dispatch(updateModalInfo({ show: true, result: error.toString(), type: 'error', message: 'Failed' }));
    });
    setModalVisible(false);
  };

  const handleDelete = async () => {
    dispatch(deleteSelectedNewsRoom(selectedNewsID));
    dispatch(deleteNews(selectedNewsID)).then((result) => {
      if (!result.payload) {
        dispatch(newsRoomData());
        dispatch(toggleModal());
        dispatch(updateModalInfo({ show: true, result: 'News Deleted Successfully!', type: 'success', message: 'Success!' }));
      } else {
        dispatch(toggleModal());
        dispatch(updateModalInfo({ show: true, result: 'News Deletion Failed!', type: 'error', message: 'Failed' }));
      }
    }).catch((error) => {
      dispatch(updateModalInfo({ show: true, result: error.toString(), type: 'error', message: 'Failed' }));
    });
    setDeleteModal(false);
  };

  // Format publish date nicely
  const publishDate = selectedNewsData?.publish_date
    ? new Date(selectedNewsData.publish_date).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })
    : '';

    const sectionData = selectedNewsData?.section_data;

    const SECTION_ORDER = [
  'CARBON PRICE',
  'BEHAVIOR AND SPECULATION',
  'ENERGY MIX',
  'AZOLLA VIEW',
];

const formatLabel = (key) => {
  return key
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

  return (
    <div className="nm-display-wrapper">
      {/* Article header */}
      <div style={{ marginBottom: '1.25rem', paddingBottom: '1.25rem', borderBottom: '1px solid #e2e8f0' }}>
        <div style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '0.5rem' }}>
          {publishDate}
        </div>
        <h1 style={{ fontSize: '1.35rem', fontWeight: '700', color: '#0f172a', lineHeight: '1.4', marginBottom: '0.5rem' }}>
          {selectedNewsData?.title}
        </h1>
       
      </div>

      {/* Thumbnail */}
      {selectedNewsData?.thumbnail_url && (
        <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '1.25rem', paddingBottom: '1.25rem', borderBottom: '1px solid #e2e8f0' }}>
          <img
            className="newsroom-thumbnail"
            src={selectedNewsData.thumbnail_url}
            alt="news"
            
          />
        </div>
      )}

      {/* Content */}
      {selectedNewsData?.section_data && typeof selectedNewsData.section_data === 'object' && !Array.isArray(selectedNewsData.section_data) ? (
        <div style={{ marginBottom: '1.5rem' }}>
          {/* Key Metrics Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginBottom: '1.5rem' }}>
            {['avg_surplus_price', 'bid_ask_spread', 'pooling_deadline', 'banking_deadline'].map((key) => (
              selectedNewsData.section_data[key] && (
                <div
                  key={key}
                  style={{ paddingBottom: '1rem', borderBottom: '1px solid #e2e8f0' }}
                >
                  <div style={{ fontSize: '0.9rem', fontWeight: '700', color: '#0f172a', marginBottom: '0.5rem' }}>
                    {key
                      .replace(/_/g, ' ')
                      .split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' ')}
                  </div>
                  <div style={{ fontSize: '0.85rem', color: '#475569' }}>
                    {key === 'avg_surplus_price' ? `€${selectedNewsData.section_data[key]}` : selectedNewsData.section_data[key]}
                  </div>
                </div>
              )
            ))}
          </div>

          {/* Content Sections */}
         {SECTION_ORDER.map((key) => {
  const value = sectionData[key];

  // Don't display sections that are not present in the API response
  if (!value) return null;

  return (
    <div
      key={key}
      style={{
        paddingBottom: '1rem',
        borderBottom: '1px solid #e2e8f0'
      }}
    >
      <div
        style={{
          fontSize: '0.95rem',
          fontWeight: '700',
          color: '#0f172a',
          marginBottom: '0.5rem'
        }}
      >
        {formatLabel(key)}
      </div>

      <div
        style={{
          fontSize: '0.85rem',
          color: '#475569',
          lineHeight: '1.7'
        }}
      >
        {value}
      </div>
    </div>
  );
})}
        </div>
      ) : (
        <div
          style={{ color: '#475569', lineHeight: '1.75', fontSize: '0.8rem', marginBottom: '1.5rem' }}
          dangerouslySetInnerHTML={{ __html: selectedNewsData?.description }}
        />
      )}

      {/* Footer: edit/delete + likes */}
      <div style={{
        display: 'flex',
        justifyContent: isAdmin ? 'space-between' : 'flex-end',
        alignItems: 'center',
        paddingTop: '1rem',
        borderTop: '1px solid #e2e8f0'
      }}>
        {isAdmin && (
          <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
            <img onClick={openModal} src={EditIcon} alt="Edit" style={{ cursor: 'pointer', width: '20px', height: '20px', opacity: 0.7 }} />
            <img onClick={() => setDeleteModal(true)} src={deleteNotificationIcon} alt="delete" style={{ cursor: 'pointer', width: '20px', height: '20px', opacity: 0.7 }} />
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <span style={{ fontSize: '0.9rem', color: '#475569', fontWeight: '500' }}>{selectedNewsData?.liked_count ?? 0}</span>
          <LikeIcon
            onClick={() => changeLikeStatus(selectedNewsData?.id, !selectedNewsData?.liked_status)}
            fill={selectedNewsData?.liked_status ? '#2563eb' : 'none'}
            style={{ cursor: 'pointer', width: '22px', height: '22px' }}
          />
        </div>
      </div>

      {/* Edit Modal */}
      <Modal title="Edit News" visible={modalVisible} onCancel={() => setModalVisible(false)} footer={null} className="uploadNewsModal" style={{ height: '650px', overflow: 'auto' }}>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item name="title" label="Title" rules={[{ required: true, message: 'Please input the title' }]}>
            <Input placeholder="Title" />
          </Form.Item>
          <Form.Item name="description" label="Description" rules={[{ required: true, message: 'Please input the description' }]}>
            <ReactQuill placeholder="Description" />
          </Form.Item>
          <Form.Item name="publishDate" label="Publish Date" rules={[{ required: true, message: 'Please select the publish date' }]}>
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="thumbnail"
            label="Thumbnail"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
            rules={[{ required: true, message: 'Please upload the thumbnail' }]}
          >
            <Upload beforeUpload={() => false}>
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">Submit</Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* Delete Modal */}
      <Modal
        title="Confirm Delete"
        open={deleteModal}
        onOk={handleDelete}
        onCancel={() => setDeleteModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setDeleteModal(false)} style={{ color: 'red', backgroundColor: 'black' }}>Cancel</Button>,
          <Button key="delete" type="primary" danger onClick={handleDelete} style={{ backgroundColor: 'red', color: 'white' }}>Delete</Button>,
        ]}
      >
        <p>Are you sure you want to delete this item?</p>
      </Modal>
    </div>
  );
  
};

export default NewsDisplay;
